const getParentOrigin = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('parentOrigin');
};

export const postMessageScrollUp = () => {
  const parentOrigin = getParentOrigin();
  parentOrigin && window.top.postMessage('scrollUp', parentOrigin);
};

export const postMessageHeight = (elem) => {
  const parentOrigin = getParentOrigin();
  elem && parentOrigin && window.top.postMessage(`height:${elem.clientHeight}`, parentOrigin);
};
